import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import LeavePillWithPopover from 'modules/attendance/components/ClockIn/LeavePillWithPopover'
import { LeaveInfo } from 'modules/attendance/store/models/CalendarDay'

interface Props {
  leaves: LeaveInfo[]
}

export default function Leaves({ leaves }: Props) {
  // Because we want to add padding and gaps in this collection component it's better to return early if the leaves are empty
  if (leaves.length === 0) return null

  return (
    <Box flexWrap="noWrap" flexDirection="row" paddingX="s24" width="fit-content">
      {leaves.map((leaveInfo) => (
        <LeavePillWithPopover key={leaveInfo.name} leaveInfo={leaveInfo} />
      ))}
    </Box>
  )
}
